import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    const storedPass = JSON.parse(localStorage.getItem('pass'));
    if (storedPass && storedPass.username === username && storedPass.password === password) {
      localStorage.setItem('isLoggedIn', 'true');
      navigate('/admin/news');
    } else {
      alert('Неверный логин или пароль');
    }
  };

  const containerVariants = {
    hidden: { opacity: 0, y: -50 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: 'easeOut' } },
  };

  const inputVariants = {
    focus: { scale: 1.02, transition: { duration: 0.3, ease: 'easeInOut' } },
  };

  const buttonVariants = {
    hover: { scale: 1.05, transition: { duration: 0.3, ease: 'easeInOut' } },
  };

  return (
    <motion.div
      variants={containerVariants}
      initial="hidden"
      animate="visible"
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        backgroundColor: '#f4f4f4',
        overflowX: 'hidden',
      }}
    >
      <motion.h2
        style={{
          fontSize: '2.5rem',
          marginBottom: '2rem',
          color: '#007aff',
          fontWeight: 'bold',
        }}
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1, ease: 'easeInOut' }}
      >
        Вход
      </motion.h2>
      <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', width: '90%', maxWidth: '300px' }}>
        <motion.input
          type="text"
          placeholder="Логин"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          required
          style={{
            marginBottom: '1rem',
            padding: '1rem',
            borderRadius: '10px',
            border: '1px solid #ccc',
            outline: 'none',
            transition: 'border-color 0.3s ease',
            backgroundColor: '#fff',
            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
          }}
          variants={inputVariants}
          whileFocus="focus"
        />
        <motion.input
          type="password"
          placeholder="Пароль"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          style={{
            marginBottom: '1rem',
            padding: '1rem',
            borderRadius: '10px',
            border: '1px solid #ccc',
            outline: 'none',
            transition: 'border-color 0.3s ease',
            backgroundColor: '#fff',
            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
          }}
          variants={inputVariants}
          whileFocus="focus"
        />
        <motion.button
          type="submit"
          style={{
            padding: '1rem',
            borderRadius: '10px',
            border: 'none',
            backgroundColor: '#007aff',
            color: '#fff',
            fontWeight: 'bold',
            cursor: 'pointer',
            transition: 'background-color 0.3s ease',
          }}
          variants={buttonVariants}
          whileHover="hover"
        >
          Войти
        </motion.button>
      </form>
    </motion.div>
  );
};

export default Login;